export default __webpack_public_path__ + "static/media/show_professor.4d917367.jpeg";